import React from "react";
import ConsumptionJournal from "@core/components/journal/ConsumptionJournal";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";

const DatePollsJournalSimple: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen-safe bg-gray-50">
      <ProductHeader productType="date" showAuth={true} />
      <div className="flex flex-1">
        {/* Sidebar auto-suffisante avec son hamburger */}
        <ProductSidebar productType="date" />

        {/* Contenu principal */}
        <div className="flex-1">
          <ConsumptionJournal />
        </div>
      </div>
    </div>
  );
};

export default DatePollsJournalSimple;
